import React from 'react'
import { withIcon } from '../../withIcon'

function MenuIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.375 6C3.375 5.65482 3.65482 5.375 4 5.375H20C20.3452 5.375 20.625 5.65482 20.625 6C20.625 6.34518 20.3452 6.625 20 6.625H4C3.65482 6.625 3.375 6.34518 3.375 6ZM3.375 12C3.375 11.6548 3.65482 11.375 4 11.375H20C20.3452 11.375 20.625 11.6548 20.625 12C20.625 12.3452 20.3452 12.625 20 12.625H4C3.65482 12.625 3.375 12.3452 3.375 12ZM3.375 18C3.375 17.6548 3.65482 17.375 4 17.375H20C20.3452 17.375 20.625 17.6548 20.625 18C20.625 18.3452 20.3452 18.625 20 18.625H4C3.65482 18.625 3.375 18.3452 3.375 18Z" fill={color}/>
    </svg>
  )
}

export default withIcon(MenuIcon)
